// reducer for navigation menu

import {
  GET_NAVIGATION_MENU,
  GET_NAVIGATION_MENU_SUCCESS,
  GET_NAVIGATION_MENU_FAILURE,
  ROLE_BASED_NAVIGATION_MENU,
  ROLE_BASED_NAVIGATION_MENU_SUCCESS,
  ROLE_BASED_NAVIGATION_MENU_FAILURE,
  GET_MENU_NAVIGATION_LIST,
  GET_MENU_NAVIGATION_LIST_SUCCESS,
  GET_MENU_NAVIGATION_LIST_FAILURE,
  CREATE_SINGLE_MENU_NAVIGATION,
  CREATE_SINGLE_MENU_NAVIGATION_SUCCESS,
  CREATE_SINGLE_MENU_NAVIGATION_FAILURE,
  UPDATE_SINGLE_MENU_NAVIGATION,
  UPDATE_SINGLE_MENU_NAVIGATION_SUCCESS,
  UPDATE_SINGLE_MENU_NAVIGATION_FAILURE,
  DELETE_SINGLE_MENU_NAVIGATION,
  DELETE_SINGLE_MENU_NAVIGATION_SUCCESS,
  DELETE_SINGLE_MENU_NAVIGATION_FAILURE,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS_SUCCESS,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS_FAILURE,
  GET_SINGLE_NAVIGATION_MENU,
  GET_SINGLE_NAVIGATION_MENU_SUCCESS,
  GET_SINGLE_NAVIGATION_MENU_FAILURE,
  GET_MENU_ITEM_LIST,
  GET_MENU_ITEM_LIST_SUCCESS,
  GET_MENU_ITEM_LIST_FAILURE,
  GET_SINGLE_MENU_ITEM_DATA,
  GET_SINGLE_MENU_ITEM_DATA_SUCCESS,
  GET_SINGLE_MENU_ITEM_DATA_FAILURE,
  CREATE_SINGLE_MENU_ITEM,
  CREATE_SINGLE_MENU_ITEM_SUCCESS,
  CREATE_SINGLE_MENU_ITEM_FAILURE,
  UPDATE_SINGLE_MENU_ITEM,
  UPDATE_SINGLE_MENU_ITEM_SUCCESS,
  UPDATE_SINGLE_MENU_ITEM_FAILURE,
  DELETE_SINGLE_MENU_ITEM,
  DELETE_SINGLE_MENU_ITEM_SUCCESS,
  DELETE_SINGLE_MENU_ITEM_FAILURE,
  CREATE_MASTER_MENU_NAV_ITEM,
  CREATE_MASTER_MENU_NAV_ITEM_SUCCESS,
  CREATE_MASTER_MENU_NAV_ITEM_FAILURE,
  // Global menus - Task 24886
  GET_MASTER_MENU_NAV_LIST,
  GET_MASTER_MENU_NAV_LIST_SUCCESS,
  GET_MASTER_MENU_NAV_LIST_FAILURE,
  GET_MASTER_MENU_NAV_DATA,
  GET_MASTER_MENU_NAV_DATA_SUCCESS,
  GET_MASTER_MENU_NAV_DATA_FAILURE,
  CREATE_MASTER_MENU_NAV_SUCCESS,
  CREATE_MASTER_MENU_NAV_FAILURE,
  UPDATE_MASTER_MENU_NAV,
  UPDATE_MASTER_MENU_NAV_SUCCESS,
  UPDATE_MASTER_MENU_NAV_FAILURE,
  DELETE_MASTER_MENU_NAV_SUCCESS,
  DELETE_MASTER_MENU_NAV_FAILURE,
  ROLLOUT_MASTER_MENU_NAV,
  ROLLOUT_MASTER_MENU_NAV_SUCCESS,
  ROLLOUT_MASTER_MENU_NAV_FAILURE,
} from "./actionType";

const initialState = {
  loading: false,
  navigationMenu: [],
  role: "",
  menuNavigationList: [],
  createSingleMenuNavigationSuccess: [],
  createSingleMenuNavigationError: [],
  updateSingleMenuNavigationSuccess: [],
  updateSingleMenuNavigationError: [],
  deleteSingleMenuNavigationSuccess: [],
  deleteSingleMenuNavigationError: [],
  availableMenuNavigationItems: [],
  availableMenuNavigationItemsError: [],
  singleNavigationMenu: [],
  singleNavigationMenuError: [],
  menuItemList: [],
  menuItemListLoading: false,
  menuItemListError: [],
  singleMenuItemData: [],
  singleMenuItemDataLoading: false,
  singleMenuItemDataError: [],
  createSingleMenuItemSuccess: [],
  createSingleMenuItemError: [],
  updateSingleMenuItemSuccess: [],
  updateSingleMenuItemSuccessLoading: false,
  updateSingleMenuItemError: [],
  deleteSingleMenuItemSuccess: [],
  deleteSingleMenuItemError: [],
  //CREATE_MASTER_MENU_NAV_ITEM
  createMasterMenuNavItemSuccess: [],
  createMasterMenuNavItemError: [],
  // Global menus - Task 24886
  masterMenuNavList: [],
  masterMenuNavListLoading: false,
  masterMenuNavListError: [],
  masterMenuNavData: [],
  masterMenuNavDataLoading: false,
  masterMenuNavDataError: [],
  createMasterMenuNavSuccess: [],
  createMasterMenuNavError: [],
  updateMasterMenuNavSuccess: [],
  updateMasterMenuNavLoading: false,
  updateMasterMenuNavError: [],
  deleteMasterMenuNavSuccess: [],
  deleteMasterMenuNavError: [],
  rolloutMasterMenuNavSuccess: [],
  rolloutMasterMenuNavLoading: false,
  rolloutMasterMenuNavError: [],
};

const NavigationMenu = (state = initialState, action) => {
  switch (action.type) {
    case GET_NAVIGATION_MENU:
      return {
        ...state,
        loading: true,
        navigationMenu: action.payload,
      };
    case GET_NAVIGATION_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        navigationMenu: action.payload,
      };
    case GET_NAVIGATION_MENU_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ROLE_BASED_NAVIGATION_MENU:
      return {
        ...state,
        loading: true,
        role: action.payload,
      };
    case ROLE_BASED_NAVIGATION_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        role: action.payload,
      };
    case ROLE_BASED_NAVIGATION_MENU_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case GET_MENU_NAVIGATION_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_MENU_NAVIGATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        menuNavigationList: action.payload,
      };
    case GET_MENU_NAVIGATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case CREATE_SINGLE_MENU_NAVIGATION:
      return {
        ...state,
        loading: true,
      };
    case CREATE_SINGLE_MENU_NAVIGATION_SUCCESS:
      return {
        ...state,
        loading: false,
        createSingleMenuNavigationSuccess: action.payload,
      };
    case CREATE_SINGLE_MENU_NAVIGATION_FAILURE:
      return {
        ...state,
        loading: false,
        createSingleMenuNavigationError: action.payload,
      };
    case UPDATE_SINGLE_MENU_NAVIGATION:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_SINGLE_MENU_NAVIGATION_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSingleMenuNavigationSuccess: action.payload,
      };
    case UPDATE_SINGLE_MENU_NAVIGATION_FAILURE:
      return {
        ...state,
        loading: false,
        updateSingleMenuNavigationError: action.payload,
      };
    case DELETE_SINGLE_MENU_NAVIGATION:
      return {
        ...state,
        loading: true,
      };
    case DELETE_SINGLE_MENU_NAVIGATION_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSingleMenuNavigationSuccess: action.payload,
      };
    case DELETE_SINGLE_MENU_NAVIGATION_FAILURE:
      return {
        ...state,
        loading: false,
        deleteSingleMenuNavigationError: action.payload,
      };
    case GET_AVAILABLE_MENU_NAVIGATION_ITEMS:
      return {
        ...state,
        loading: true,
      };
    case GET_AVAILABLE_MENU_NAVIGATION_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        availableMenuNavigationItems: action.payload,
      };
    case GET_AVAILABLE_MENU_NAVIGATION_ITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        availableMenuNavigationItemsError: action.payload,
      };
    case GET_SINGLE_NAVIGATION_MENU:
      return {
        ...state,
        loading: true,
      };

    case GET_SINGLE_NAVIGATION_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        singleNavigationMenu: action.payload,
      };
    case GET_SINGLE_NAVIGATION_MENU_FAILURE:
      return {
        ...state,
        loading: false,
        singleNavigationMenuError: action.payload,
      };
    case GET_MENU_ITEM_LIST:
      return {
        ...state,
        menuItemListLoading: true,
      };
    case GET_MENU_ITEM_LIST_SUCCESS:
      return {
        ...state,
        menuItemListLoading: false,
        menuItemList: action.payload,
      };
    case GET_MENU_ITEM_LIST_FAILURE:
      return {
        ...state,
        menuItemListLoading: false,
        menuItemListError: action.payload,
      };
    case GET_SINGLE_MENU_ITEM_DATA:
      return {
        ...state,
        singleMenuItemDataLoading: true,
      };
    case GET_SINGLE_MENU_ITEM_DATA_SUCCESS:
      return {
        ...state,
        singleMenuItemDataLoading: false,
        singleMenuItemData: action.payload,
      };
    case GET_SINGLE_MENU_ITEM_DATA_FAILURE:
      return {
        ...state,
        singleMenuItemDataLoading: false,
        singleMenuItemDataError: action.payload,
      };
    case CREATE_SINGLE_MENU_ITEM:
      return {
        ...state,
      };
    case CREATE_SINGLE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        createSingleMenuItemSuccess: action.payload,
      };
    case CREATE_SINGLE_MENU_ITEM_FAILURE:
      return {
        ...state,
        createSingleMenuItemError: action.payload,
      };
    case UPDATE_SINGLE_MENU_ITEM:
      return {
        ...state,
        updateSingleMenuItemSuccessLoading: true,
      };
    case UPDATE_SINGLE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        updateSingleMenuItemSuccess: action.payload,
        updateSingleMenuItemSuccessLoading: false,
      };
    case UPDATE_SINGLE_MENU_ITEM_FAILURE:
      return {
        ...state,
        updateSingleMenuItemError: action.payload,
        updateSingleMenuItemSuccessLoading: false,
      };
    case DELETE_SINGLE_MENU_ITEM:
      return {
        ...state,
      };
    case DELETE_SINGLE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        deleteSingleMenuItemSuccess: action.payload,
      };
    case DELETE_SINGLE_MENU_ITEM_FAILURE:
      return {
        ...state,
        deleteSingleMenuItemError: action.payload,
      };
    case CREATE_MASTER_MENU_NAV_ITEM:
      return {
        ...state,
      };
    case CREATE_MASTER_MENU_NAV_ITEM_SUCCESS:
      return {
        ...state,
        createMasterMenuNavItemSuccess: action.payload,
      };
    case CREATE_MASTER_MENU_NAV_ITEM_FAILURE:
      return {
        ...state,
        createMasterMenuNavItemError: action.payload,
      };

    // ---------------- Global menus - Task 24886 ----------------
    case GET_MASTER_MENU_NAV_LIST:
      return { ...state, masterMenuNavListLoading: true };
    case GET_MASTER_MENU_NAV_LIST_SUCCESS:
      return {
        ...state,
        masterMenuNavListLoading: false,
        masterMenuNavList: action.payload,
      };
    case GET_MASTER_MENU_NAV_LIST_FAILURE:
      return {
        ...state,
        masterMenuNavListLoading: false,
        masterMenuNavListError: action.payload,
      };

    case GET_MASTER_MENU_NAV_DATA:
      return { ...state, masterMenuNavDataLoading: true };
    case GET_MASTER_MENU_NAV_DATA_SUCCESS:
      return {
        ...state,
        masterMenuNavDataLoading: false,
        masterMenuNavData: action.payload,
      };
    case GET_MASTER_MENU_NAV_DATA_FAILURE:
      return {
        ...state,
        masterMenuNavDataLoading: false,
        masterMenuNavDataError: action.payload,
      };

    case CREATE_MASTER_MENU_NAV_SUCCESS:
      return { ...state, createMasterMenuNavSuccess: action.payload };
    case CREATE_MASTER_MENU_NAV_FAILURE:
      return { ...state, createMasterMenuNavError: action.payload };

    case UPDATE_MASTER_MENU_NAV:
      return { ...state, updateMasterMenuNavLoading: true };
    case UPDATE_MASTER_MENU_NAV_SUCCESS:
      return {
        ...state,
        updateMasterMenuNavLoading: false,
        updateMasterMenuNavSuccess: action.payload,
      };
    case UPDATE_MASTER_MENU_NAV_FAILURE:
      return {
        ...state,
        updateMasterMenuNavLoading: false,
        updateMasterMenuNavError: action.payload,
      };

    case DELETE_MASTER_MENU_NAV_SUCCESS:
      return { ...state, deleteMasterMenuNavSuccess: action.payload };
    case DELETE_MASTER_MENU_NAV_FAILURE:
      return { ...state, deleteMasterMenuNavError: action.payload };

    // Rollout walks every company database, so it is the one call here long
    // enough to need its own spinner rather than a toast at the end.
    case ROLLOUT_MASTER_MENU_NAV:
      return { ...state, rolloutMasterMenuNavLoading: true };
    case ROLLOUT_MASTER_MENU_NAV_SUCCESS:
      return {
        ...state,
        rolloutMasterMenuNavLoading: false,
        rolloutMasterMenuNavSuccess: action.payload,
      };
    case ROLLOUT_MASTER_MENU_NAV_FAILURE:
      return {
        ...state,
        rolloutMasterMenuNavLoading: false,
        rolloutMasterMenuNavError: action.payload,
      };


    default:
      return state;
  }
};

export default NavigationMenu;
